import React from 'react';

export const MediaPreview = ({ type, url }) => {
  if (!url) return null;

  if (type === 'image') {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" className="block mt-1 mb-2">
        <img 
          src={url} 
          alt="Media" 
          className="rounded-lg max-h-64 object-contain shadow-sm border border-gray-100 hover:opacity-95 transition-opacity" 
        />
      </a>
    );
  }

  if (type === 'audio') {
    return (
      <div className="mt-1 mb-2">
        <audio controls className="max-w-[240px] h-10 outline-none">
          <source src={url} type="audio/mpeg" />
          <source src={url} type="audio/ogg" />
          Your browser does not support the audio element.
        </audio>
      </div>
    );
  }

  // Fallback for document or unknown types
  return (
    <a 
      href={url} 
      target="_blank" 
      rel="noopener noreferrer" 
      className="flex items-center gap-3 bg-white border border-gray-200 p-3 rounded-lg hover:bg-gray-50 transition-colors shadow-sm mt-1 mb-2 max-w-sm group"
    >
      <div className="w-10 h-10 bg-red-50 text-red-500 rounded-md flex items-center justify-center group-hover:bg-red-100 transition-colors">
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-800 truncate">Document Attached</p>
        <p className="text-xs text-gray-500 hover:text-purple-600 truncate transition-colors">Click to view/download</p>
      </div>
    </a>
  );
};
